var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticStyle:{"position":"absolute","left":"10px","top":"10px","z-index":"1000"}},[_c('div',{staticClass:"ls_count"},[_vm._v(_vm._s(_vm.videoCount))])]),_c('div',{attrs:{"id":"J_prismPlayer"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }